import React from "react";

import { BulletList, BulletListType } from "@at/design-system-patterns";

import { setLeasingModal } from "../../../../../../contexts/leasing/actions/leasing.actions";
import { useLeasingDispatchContext } from "../../../../../../contexts/leasing/context/leasing.context";
import { LeasingModals } from "../../../../../../contexts/leasing/types/leasing.types";
import * as Styled from "../how-leasing-works-tabs.styled";

export const WhatYouGet = () => {
  const dispatch = useLeasingDispatchContext();

  const handleOpenAboutModal = () => {
    dispatch(
      setLeasingModal({
        show: true,
        type: LeasingModals.WHAT_YOU_GET_WHEN_YOU_LEASE,
        title: `What you get when you lease with Auto Trader`,
        footerButtonText: "Back",
      }),
    );
  };
  return (
    <Styled.LeasingPanelContainer>
      <p>When you lease with Auto Trader you get all of this:</p>
      <BulletList
        listType={BulletListType.STANDARD}
        items={[
          `Full manufacturer’s warranty`,
          `Road tax and roadside assistance included`,
          `No admin fees`,
          `Free returns within 30 days*`,
        ]}
      />
      <Styled.LeasingTabsButton
        onInteraction={() => handleOpenAboutModal()}
        text="Learn more about returns and what you get"
        displayType="tertiary"
        underline
      />
    </Styled.LeasingPanelContainer>
  );
};
